import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
//import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
//import { i18nBackendConfig as backendOptions } from './i18next-xhr.config'

const languages = ['nl', 'en', 'fr']

let loadedResources = {}
languages.forEach(item => {
  const results = require(`./media/locales/${item}/translation.json`)
  loadedResources[item] = { translation: results }
})

export const i18nOptions = () => ({
  //backend: backendOptions,
  lng: 'nl',
  fallbackLng: 'en',
  preload: languages,
  nonExplicitWhitelist: true,
  lowerCaseLng: true,
  debug: false,
  partialBundledLanguages: true,
  nsSeparator: '~',

  resources: loadedResources,
  /*saveMissing: true,
  saveMissingTo: "all",
  saveMissingPlurals: true,
  updateMissing: true,
  missingKeyHandler: async (lng, ns, keys, fallbackValue) => {
    console.log("adding missing keys", keys);
    await fetch(`/api/locales/add/${lng}/${ns}`, {
      method: "POST",
      headers: authorizedHeader(),
      body: JSON.stringify({ [keys]: keys })
    })
      .then(checkHttpStatus)
      .then(response => {
        console.log("new keys added", keys);
        return response.json();
      })
      .catch(err => {
        console.log(err);
      });
  },*/

  initImmediate: true,
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added',
    useSuspense: true,
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'b', 'strong', 'i'],
  },
})

i18n
  //.use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)

export default i18n
